/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtodeleteevent3Inputs */

const en_failedtodeleteevent3 = /** @type {(inputs: Failedtodeleteevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete event`)
};

const de_failedtodeleteevent3 = /** @type {(inputs: Failedtodeleteevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event konnte nicht gelöscht werden`)
};

/**
* | output |
* | --- |
* | "Failed to delete event" |
*
* @param {Failedtodeleteevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtodeleteevent3 = /** @type {((inputs?: Failedtodeleteevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtodeleteevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtodeleteevent3(inputs)
	return de_failedtodeleteevent3(inputs)
});
export { failedtodeleteevent3 as "failedToDeleteEvent" }